import React from 'react';
import '../less/installment_from_statement.less';
import {Preloader} from 'MWC';
import {Link} from 'MWComponents';
import Calculator from '../../../auxiliary-components/Calculator';
import TabsNew from '../../../auxiliary-components/shared/TabsNew';
import UsageBlock from '../../../auxiliary-components/shared/UsageBlock';
import Banner from '../../../auxiliary-components/shared/Banner';
import QuestionsBlock from '../../../auxiliary-components/shared/QuestionsBlock';
import TextAboveFooter from '../../../auxiliary-components/shared/TextAboveFooter/views/TextAboveFooter.c';
import installment_from_statement_banner_img from '../img/installment_from_statement_banner_img.png';
import usage_block_data from '../enums/installment_from_statement_usage_block.json';
import repayment_usage_block_data from '../enums/installment_from_statement_repayment_usage_block.json';
import questions from '../enums/installment_from_statement_questions.json';
import {downloadA24} from '../../../services/urls/urls';
import FilesForDownload from '../../../auxiliary-components/shared/FilesForDownload/views/file.c';
import how_to_1 from "../img/inst_from_statement/how_to_1.png";
import how_to_2 from "../img/inst_from_statement/how_to_2.png";
import how_to_3 from "../img/inst_from_statement/how_to_3.png";
import how_to_4 from "../img/inst_from_statement/how_to_4.png";
import HowToBlock from "../../../auxiliary-components/shared/HowToBlock";

export default function template() {
    const isMobile = this.isViewportMobile(),
        page = 'installment_from_statement',
        model = this.getModel(),
        modes = [
            {mode: 'info', title: 'GREEN_CARD_NAV_TITLE_1'},
            {mode: 'repayment', title: 'INSTALLMENT_FROM_STATEMENT_NAV_TITLE_1'},
            {mode: 'questions', title: 'GREEN_CARD_NAV_TITLE_3'}
        ],
      howToItems = [
          { img: how_to_1, title: 'INSTALLMENT_FROM_STATEMENT_HOW_TO_TITLE_1', text: 'INSTALLMENT_FROM_STATEMENT_HOW_TO_TEXT_1' },
          { img: how_to_2, title: 'INSTALLMENT_FROM_STATEMENT_HOW_TO_TITLE_2', text: 'INSTALLMENT_FROM_STATEMENT_HOW_TO_TEXT_2' },
          { img: how_to_3, title: 'INSTALLMENT_FROM_STATEMENT_HOW_TO_TITLE_3', text: 'INSTALLMENT_FROM_STATEMENT_HOW_TO_TEXT_3' },
          { img: how_to_4, title: 'INSTALLMENT_FROM_STATEMENT_HOW_TO_TITLE_4', text: 'INSTALLMENT_FROM_STATEMENT_HOW_TO_TEXT_4' }
      ],
        calculator = !model.creditSum ? (
            ''
        ) : (
            <div className='credit-calculator'>
                <div className='content'>
                    <Calculator
                        model={this.getModel()}
                        type={this.state.selectedType}
                        {...this.props}
                    />
                </div>
            </div>
        );

    return !model.creditSum ? (
        <div className='preload-wrapper'>
            <Preloader />
        </div>
    ) : (
        <div className='installment-from-statement'>
            <Banner
              img={installment_from_statement_banner_img}
              text={'INSTALLMENT_FROM_STATEMENT_BANNER_TEXT'}
              textMob={'INSTALLMENT_FROM_STATEMENT_BANNER_TEXT'}
              title={'INSTALLMENT_FROM_STATEMENT_BANNER_TITLE'}
              btnText={'ABANK_24_BANNER_BUTTON_TEXT_2'}
              link={{link: downloadA24, target: '_blank', text: 'ABANK_24_JOIN_BLOCK_BUTTON'}}
              page={page}
              isMobile={isMobile}
              />

            <TabsNew
                modes={modes}
                isMobile={isMobile}
                page={page}
                toggle={this.toggleMode}
                mode={this.state.mode}
            >
                <div className='wrapper' type={modes[0].mode}>
                    <div className='content'>
                        <UsageBlock isMobile={isMobile} page={page} data={usage_block_data} />
                    </div>
                    {calculator}
                    <div className='content'>
                        <div className="how-to-block-wrapper">
                            <div className="block-title">{this.l10n("INSTALLMENT_FROM_STATEMENT_HOW_TO_TITLE")}</div>
                            <div className="block-text">{this.l10n("INSTALLMENT_FROM_STATEMENT_HOW_TO_TEXT")}</div>
                            <HowToBlock data={howToItems} isMobile={isMobile} page={'green-card'}></HowToBlock>
                        </div>
                    </div>
                </div>
                <div className='wrapper' type={modes[1].mode}>
                    <div className='repayment-commission'>
                        <div className='content'>
                            <div
                                className='block-title'
                                dangerouslySetInnerHTML={{
                                    __html: this.l10n('INSTALLMENT_FROM_STATEMENT_REPAYMENT_TITLE')
                                }}
                            />
                            <ul className='repayment-commission-list'>
                                <li
                                    className='repayment-commission-list-item'
                                    dangerouslySetInnerHTML={{
                                        __html: this.l10n(
                                            'INSTALLMENT_FROM_STATEMENT_REPAYMENT_TEXT_1'
                                        )
                                    }}
                                />
                                <li className='repayment-commission-list-item'>
                                    {this.l10n('INSTALLMENT_FROM_STATEMENT_REPAYMENT_TEXT_2')}
                                </li>
                            </ul>
                            <div className='repayment-commission-list-item'>
                                {this.l10n('INSTALLMENT_FROM_STATEMENT_REPAYMENT_TEXT_3')}
                            </div>
                        </div>
                        <div className='repayment-usage-block-wrapper'>
                            <div className='content'>
                                <UsageBlock
                                    isMobile={isMobile}
                                    page={page}
                                    data={repayment_usage_block_data}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='wrapper' type={modes[2].mode}>
                    <div className='content'>
                        <QuestionsBlock isMobile={isMobile} page={page} data={questions} />
                    </div>
                </div>
            </TabsNew>

            <FilesForDownload page={'new-design'} lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}/>

            <div
                className={`disclaimer-wrapper tab-${
                    this.state.mode === 'info' ? 'active' : 'hidden'
                }`}
            >
                <TextAboveFooter widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')} isMobile={isMobile} />
            </div>
        </div>
    );
}
